import { useState, useEffect, useMemo } from 'react';
import {
  mockGuaranteePurchases,
  mockCancelledPurchases,
  mockIneligiblePurchases,
} from '../data/mock/guaranteesMockData';
import { PRODUCT_FAMILY_ALL } from '../constants/productFamily';

const DEFAULT_PAGE_SIZE = 25;

const TAB_DATA_MAP = {
  guarantee: mockGuaranteePurchases,
  cancelled: mockCancelledPurchases,
  ineligible: mockIneligiblePurchases,
};

const useMockGuarantees = ({
  productFamily, tab, page, searchFields,
}) => {
  const [loading, setLoading] = useState(false);

  const allData = TAB_DATA_MAP[tab] || [];

  const filteredData = useMemo(() => {
    let result = productFamily === PRODUCT_FAMILY_ALL
      ? allData
      : allData.filter(record => record.productFamily === productFamily);

    if (searchFields) {
      const { vin, dealerNumbers } = searchFields;
      if (vin) {
        const vinLower = vin.toLowerCase();
        result = result.filter(r => {
          const recordVin = tab === 'cancelled'
            ? r.vin
            : r.guaranteeOffer.vehicleInformation.vin;
          return recordVin && recordVin.toLowerCase().includes(vinLower);
        });
      }
      if (dealerNumbers && dealerNumbers.length > 0) {
        const dealerNosLower = dealerNumbers.map(d => d.toLowerCase());
        result = result.filter(r => {
          const dealerNo = tab === 'cancelled'
            ? r.dealerNo
            : r.guaranteeOffer.auctionInformation.dealerNumber;
          return dealerNo && dealerNosLower.includes(dealerNo.toLowerCase());
        });
      }
    }

    return result;
  }, [allData, productFamily, tab, searchFields]);

  const totalCount = filteredData.length;
  const startIndex = (page - 1) * DEFAULT_PAGE_SIZE;
  const paginatedData = filteredData.slice(
    startIndex,
    startIndex + DEFAULT_PAGE_SIZE
  );
  const isLastPage = false;
  const startDisplay = totalCount > 0 ? startIndex + 1 : 0;
  const endDisplay = startIndex + paginatedData.length;

  // Simulate loading delay on input changes
  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    const timer = setTimeout(() => {
      if (!cancelled) setLoading(false);
    }, 350);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [productFamily, tab, page]);

  return {
    data: paginatedData,
    totalCount,
    loading,
    isLastPage,
    start: startDisplay,
    end: endDisplay,
  };
};

export default useMockGuarantees;
